export default [
    {
        path: '/cities',
        name: 'cities',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Cities.vue')
    }
]